var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 12,
    viewBox: "0 0 259 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.945 0.109473C239.086 3.25294 188.499 8.4738 129.019 7.48978C69.5392 8.47382 18.952 3.25288 1.09338 0.109412C1.09338 0.109412 0 -0.136599 0 0.10943C0 0.437427 1.09338 0.601434 1.09338 0.601434C1.09338 0.601434 39.1729 7.37112 63.963 9.53983C89.1962 11.7473 128.913 11.9993 129.019 11.9999V12C129.019 12 168.808 11.7503 194.075 9.53989C218.865 7.37118 256.945 0.601495 256.945 0.601495C256.945 0.601495 258.038 0.437488 258.038 0.109491C258.038 -0.136538 256.945 0.109473 256.945 0.109473Z",
    fill: "#0077E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.14bb7e2a.svg";
export { ForwardRef as ReactComponent };